import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from '../Reveal';
import { SectionEyebrow } from '../SectionEyebrow';
const orbits = ['Equilibrio', 'Cuerpo', 'Emociones', 'Conexión', 'Disciplina', 'Empatía', 'Claridad', 'Intuición', 'Vocación', 'Armonía'];
const orbitParticles = [{
  x: 25,
  y: 30,
  delay: 0
}, {
  x: 75,
  y: 25,
  delay: 1.5
}, {
  x: 30,
  y: 70,
  delay: 3
}, {
  x: 70,
  y: 75,
  delay: 4.5
}];
export const BigIdea: React.FC = () => {
  return <section className="relative bg-navy-mid py-28 lg:py-44 overflow-hidden" data-id="element-86">
      <div className="absolute inset-0 sacred-grid opacity-20" data-id="element-87" />
      <div className="absolute inset-0" style={{
      background: 'radial-gradient(ellipse at center, rgba(212,175,122,0.1), transparent 60%)'
    }} data-id="element-88" />

      <div className="relative max-w-6xl mx-auto px-6 lg:px-8" data-id="element-89">
        <div className="text-center mb-16 lg:mb-24" data-id="element-90">
          <Reveal data-id="element-91">
            <SectionEyebrow data-id="element-92">La idea central</SectionEyebrow>
          </Reveal>
          <Reveal delay={0.1} data-id="element-93">
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl xl:text-6xl leading-[1.1] text-ivory text-balance max-w-4xl mx-auto" style={{
            fontWeight: 300
          }} data-id="element-94">
              No necesitas convertirte en otra persona.
              <br data-id="element-95" />
              <span className="italic gold-text" style={{
              fontWeight: 400
            }} data-id="element-96">
                Necesitas armonizar todas las dimensiones
              </span>
              <br data-id="element-97" />
              de quien ya eres.
            </h2>
          </Reveal>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-98">
          {/* Orbiting visual */}
          <Reveal data-id="element-99">
            <div className="relative aspect-square max-w-[360px] sm:max-w-[460px] lg:max-w-[500px] mx-auto w-full px-8 sm:px-10" data-id="element-100">
              {/* Drifting particles inside orbit */}
              {orbitParticles.map((p, i) => <motion.div key={i} className="absolute w-1.5 h-1.5 rounded-full pointer-events-none" style={{
              left: `${p.x}%`,
              top: `${p.y}%`,
              background: '#D4AF7A',
              boxShadow: '0 0 10px rgba(212,175,122,0.7)'
            }} animate={{
              opacity: [0.2, 0.8, 0.2],
              scale: [0.8, 1.2, 0.8]
            }} transition={{
              duration: 5,
              delay: p.delay,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-101" />)}

              {/* Orbit rings */}
              {[0.4, 0.7, 1].map((s, i) => <div key={i} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full border border-gold/15" style={{
              width: `${s * 82}%`,
              height: `${s * 82}%`
            }} data-id="element-102" />)}
              {/* Center */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-28 h-28 sm:w-32 sm:h-32 rounded-full flex items-center justify-center" style={{
              background: 'radial-gradient(circle, rgba(212,175,122,0.4), rgba(212,175,122,0.05) 70%)',
              boxShadow: '0 0 80px rgba(212,175,122,0.4)'
            }} data-id="element-103">
                <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-navy-deep border border-gold/40 flex items-center justify-center" data-id="element-104">
                  <span className="font-serif italic text-gold text-sm sm:text-base" data-id="element-105">
                    Tu Ser
                  </span>
                </div>
              </div>

              {/* Orbiting points */}
              <motion.div className="absolute inset-0" animate={{
              rotate: 360
            }} transition={{
              duration: 80,
              repeat: Infinity,
              ease: 'linear'
            }} data-id="element-106">
                {orbits.map((label, i) => {
                const angle = i / orbits.length * Math.PI * 2 - Math.PI / 2;
                const x = 50 + 38 * Math.cos(angle);
                const y = 50 + 38 * Math.sin(angle);
                return <div key={label} className="absolute" style={{
                  left: `${x}%`,
                  top: `${y}%`,
                  transform: 'translate(-50%, -50%)'
                }} data-id="element-107">
                      <motion.div animate={{
                    rotate: -360
                  }} transition={{
                    duration: 80,
                    repeat: Infinity,
                    ease: 'linear'
                  }} className="flex flex-col items-center" data-id="element-108">
                        <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-gold" style={{
                      boxShadow: '0 0 16px rgba(212,175,122,0.8)'
                    }} data-id="element-109" />
                        <span className="font-serif italic text-[10px] sm:text-sm text-ivory/75 mt-1.5 sm:mt-2 whitespace-nowrap" data-id="element-110">
                          {label}
                        </span>
                      </motion.div>
                    </div>;
              })}
              </motion.div>
            </div>
          </Reveal>

          {/* Copy */}
          <Reveal delay={0.15} data-id="element-111">
            <div className="space-y-6 text-ivory/75 leading-[1.85] font-light" data-id="element-112">
              <p data-id="element-113">
                Este libro no promete una transformación superficial. Propone
                algo más profundo: mirar tu vida como un sistema completo.
              </p>
              <p data-id="element-114">
                Tu bienestar físico, tus emociones, tu mente, tu forma de
                conectar, tu disciplina, tu intuición y tu vocación no están
                separados. Todo se comunica. Todo influye. Todo forma parte de
                tu estabilidad interior.
              </p>
              <p className="font-serif italic text-xl lg:text-2xl text-gold/90 border-l-2 border-gold/40 pl-6 py-1 leading-snug" data-id="element-115">
                Cuando esas dimensiones empiezan a caminar en la misma
                dirección, la vida deja de sentirse como una batalla interna y
                comienza a sentirse como una sinfonía.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
};